import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
    <g>
    <image
       width="100"
       height="100"
       preserveAspectRatio="none"
       xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQCAYAAADnRuK4AAAAAXNSR0IArs4c6QAAGIdJREFUeF7t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"
       id="image17" />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
